import { init as cartInit } from './cart';

export class Category {
	constructor(cart) {

		this.rootSol = $('.ancestor-sol');
		this.root = $('.js-ancestor');
		this.btn_filtri = $('.c-button-filter');
		this.filtro = $('.js-filtra-per');
		this.filtro_post = $('.js-filtra-per-post');
		this.ancoraggio = $('.ancoraggio');
		this.filtri_attivi = $('.filtri-attivi a');
		this.impressions = [];

		this.actions();
		this.zoom();
	}

	zoom() {

	}

	actions() {
		this.getProdotti();

		this.btn_filtri.on('click', function(){
			$(this).toggleClass('open');
			$('.c-filtri').slideToggle(250);
		});

		this.filtro.on('change', function(e){
			if( $(this).val() != 0 ){
				$('#filtri').attr('action', $(this).val());
				$('#filtri').submit();
			}
		});
		this.filtro_post.on('change', function(e){
			$('#filtri').submit();
		});

		this.filtri_attivi.on('click', function(e){
			var _this = jQuery(this);
			$('.select-'+_this.data('filter')).val('');
			$('.select-'+_this.data('filter')).trigger('change');
		});


		if(this.ancoraggio.length > 0){

			$('html, body').animate({
				scrollTop: $(".c-button-filter").offset().top - 80
			}, 500);
		}

	}

	getProdotti() {
		if (this.root.data('id') != '') {
			let _self = this;

			let filter_string = '';
			$('.js-filtra-per-post').each(function(){
				let _this = $(this);
				filter_string += '&'+_this.attr('name')+"="+_this.val();
			});

			$.ajax({
				type: "POST",
				data: "category=" + _self.root.data('id')+"&offset="+_self.root.data('offset')+"&href="+window.location.href+filter_string,
				url: _url + 'ajax/ajax.load-products.php',
				dataType: 'JSON',
				success: function(result) {
					_self.root.append(result.html);
					_self.root.data('offset', result.offset);
					_self.rootSol.append(result.htmlSol);

					cartInit();
					_self.centerImageBg();

					if (typeof result['gtm'] != '' && result.gtm.length > 0) {
						_self.impressions = _self.impressions.concat(result.gtm);
					}

					if (result.iterazioni > 0) {
						_self.getProdotti();
					} else if (_self.impressions.length > 0) {
						window.dataLayer.push({
							'event': 'impressions',
							'ecommerce': {
								'currencyCode': 'EUR',
                'impressions': _self.impressions.slice(0, 40) // max analytics payloads of 8KB (circa 30/50 prodotti)
            }
        });
					}
				}
			});
		}
	}

	centerImageBg(){


		jQuery('.tile-thumb:not(.initialized)')

		.addClass('initialized')

		.each(function(){
			jQuery(this)
			.append('<div class="photo"></div>')
			.children('.photo').css({'background-image': 'url('+ encodeURI(jQuery(this).attr('data-image')) +')'});
		})

	}

}



// WEBPACK FOOTER //
// ./src/js/modules/category.js